module.exports = __webpack_public_path__ + "static/ocad-1a9d7bc58c7f2b3e194ee6c3229d1dff.png";